/* eslint-disable import/no-unresolved */
import ImageElement from "components/UiElement/ImageElement";
import {
  Container,
  Row,
  Col,
  // Dropdown
} from "react-bootstrap";
import { Thumbs, Navigation, FreeMode } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import "swiper/css/thumbs";
import "swiper/css/autoplay";
import { TimelineModal, NoDataFound, VideoElement } from "components/UiElement";
import { useState } from "react";
import { dayJsDateFormatter } from "utils";
import { ext } from "helpers";
import { Link } from "react-router-dom";

function TimelineSection({ timelineData, t }) {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [datas, setDatas] = useState({});
  const [showModal, setShowModal] = useState(false);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const openImageModal = () => {
    setShowModal(!showModal);
  };
  const [activeIndex, setActiveIndex] = useState();
  
  const handleAfterInit = swiper => {
    setActiveIndex(swiper.activeIndex);
  };


  return (
    <>
      <section className="evolutionSec bg-light-yellow py-80" id="timeline">
        <Container>
          <div className="commonHead text-center">
            <div className="commonHead_sub">
              {t("text.theme.chronicleLife")}
            </div>
            <h2 className="commonHead_title mb-0">
              {t("text.theme.timeLine")}
            </h2>
          </div>
          <div className="position-relative">
            {/* thumbnail  */}
            <div className="evolutionSec_inner">
              <Swiper
                onSwiper={setThumbsSwiper}
                loop={false}
                spaceBetween={0}
                slidesPerView={3}
                freeMode
                watchSlidesProgress
                modules={[FreeMode, Navigation, Thumbs]}
                className="evolutionSec_thumb mb-xl-5 mb-3"
                breakpoints={{
                  375: { slidesPerView: 3 },
                  480: { slidesPerView: 4 },
                  640: { slidesPerView: 5 },
                  768: { slidesPerView: 6 },
                  1200: { slidesPerView: 9 },
                }}
              >
                {timelineData?.length > 0 ? (
                  timelineData?.map((item, index) => {
                    return (
                      <SwiperSlide key={index} className={`${index === activeIndex ? 'swiper-slide-thumb-active' : ''}`}>
                        <div className="evolutionSec_thumbnail">
                          <p>{dayJsDateFormatter(item?.date, "MMM DD, YYYY")}</p>
                        </div>
                      </SwiperSlide>
                    );
                  })
                ) : (
                  <NoDataFound />
                )}
              </Swiper>
            </div>
            <Swiper
              loop={false}
              spaceBetween={10}
              navigation={false}
              thumbs={{
                swiper:
                  thumbsSwiper && !thumbsSwiper.destroyed ? thumbsSwiper : null,
              }}
              modules={[FreeMode, Navigation, Thumbs]}
              className="evolutionSec_slider"
              onAfterInit={handleAfterInit}
              onSlideChange={handleAfterInit}
            >
              {timelineData?.length > 0 ? (
                timelineData?.map((item, index) => {
                  return (
                    <SwiperSlide>
                      <Row className="align-items-center">
                        <Col md={6}>
                          {ext?.[item?.timelineImageUrl?.split(".")?.pop()] ===
                          "file" ? (
                            <Link
                              to={item?.timelineImageUrl}
                              target="_blank"
                              key={index}
                            >
                              <div className="evolutionSec_slider_img mb-md-0 mb-3 pdf d-block">
                                <Link
                                  to={item?.timelineImageUrl}
                                  target="_blank"
                                >
                                  <span className="evolutionSec_slider_icon">
                                    <em className="icon-pdf" />
                                  </span>
                                </Link>
                              </div>
                            </Link>
                          ) : (
                            <div
                              className={`evolutionSec_slider_img mb-md-0 mb-3${
                                ext?.[
                                  item?.timelineImageUrl?.split(".")?.pop()
                                ] === "audio"
                                  ? " audio"
                                  : ""
                              } ${
                                ext?.[
                                  item?.timelineImageUrl?.split(".")?.pop()
                                ] === "video" && " video"
                              }`}
                              onClick={() => {
                                openImageModal(item?.id);
                                setDatas(item);
                              }}
                              key={index}
                            >
                              {ext?.[
                                item?.timelineImageUrl?.split(".")?.pop()
                              ] === "video" && (
                                <>
                                  <VideoElement
                                    previewSource={item?.timelineImageUrl}
                                    extraClassName="img-fluid w-100 h-100 object-fit-cover"
                                    alt="timeline-img"
                                    controls={false}
                                  />
                                  <span className="evolutionSec_slider_icon">
                                    <em className="icon-video" />
                                  </span>
                                </>
                              )}
                              {ext?.[
                                item?.timelineImageUrl?.split(".")?.pop()
                              ] === "image" && (
                                <>
                                  <ImageElement
                                    previewSource={item?.timelineImageUrl}
                                    className="w-100 z-1 position-relative"
                                    alt="timeline-img"
                                  />
                                  {/* <span className="evolutionSec_slider_icon">
                                  <em className="icon-image" />
                                </span> */}
                                </>
                              )}
                              {ext?.[
                                item?.timelineImageUrl?.split(".")?.pop()
                              ] === "audio" && (
                                <span className="evolutionSec_slider_icon">
                                  <em className="icon-mic" />
                                </span>
                              )}
                            </div>
                          )}
                        </Col>
                        <Col md={6}>
                          <div className="evolutionSec_slider_cnt">
                            <h3 className="text-break">{item?.title}</h3>
                            <p className="text-break">{item?.description}</p>
                          </div>
                        </Col>
                      </Row>
                    </SwiperSlide>
                  );
                })
              ) : (
                <NoDataFound />
              )}
            </Swiper>
          </div>
        </Container>
      </section>
      <TimelineModal
        handleCloseModal={handleCloseModal}
        setDatas={setDatas}
        datas={datas}
        showModal={showModal}
      />
    </>
  );
}

export default TimelineSection;
